<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客户管理</el-breadcrumb-item>
      <el-breadcrumb-item>物流承运商</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
          <el-row :gutter="20">
            <el-col :span="2">
              <el-button type="primary" round size="mini" @click="newLogisticsCarrier()">添加承运商</el-button>
            </el-col>
            <el-col :span="3" >
              <el-tooltip class="item" effect="light" content="承运单位" placement="top">
                <el-input v-model="queryInfo.carrierUnit" placeholder="承运单位" size="mini" style="width: 85%;"></el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="1" style="margin-left: -2%;">
              <el-tooltip class="item" effect="light" content="搜索或保留条件刷新,可在页面中使用回车键代替" placement="top">
                <el-button icon="el-icon-search" circle size="mini"></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
          
          <el-table max-height="630" :data="logisticsCarrierList" border style="width: 100%" size="mini"
            ref="multipleTable" tooltip-effect="dark" :row-class-name="tableRowClassName">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="carrierUnit" label="承订单位"></el-table-column>
            <el-table-column prop="contacts" label="联系人"></el-table-column>
            <el-table-column prop="phone" label="联系电话" width="100%"></el-table-column>
            <el-table-column prop="addr" label="收货地址"></el-table-column>
            <el-table-column prop="mainLine" label="主营线路"></el-table-column>
            <el-table-column prop="banksAccounts" label="银行及账号"></el-table-column>
            <el-table-column prop="alipay" label="支付宝账号"></el-table-column>
            <el-table-column prop="wecatpay" label="微信支付账号"></el-table-column>
            <el-table-column prop="remark" label="备注" width="200%" show-overflow-tooltip=false></el-table-column>
            <el-table-column prop="submitter" label="提交人"></el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="150%">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="editLogisticsCarrier(scope.$index, scope.row)">修改</el-button>
                <el-button type="danger" size="mini" @click="delLogisticsCarrier(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
            
          </el-table>
    
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNum"
            :page-sizes="[10,20,50,100,200,500]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
          
        </el-card>
        
        <dev>
          <!-- 添加或修改物流承运商 -->
          <el-dialog :visible.sync="newOrEditLogisticsCarrierVisible" center width="30%">
            <el-form :model="logisticsCarrier" ref="form" label-width="96px" size="mini">
              <el-form-item label="承订单位">
                <el-input v-model="logisticsCarrier.carrierUnit" style="width: 90%;"></el-input>
              </el-form-item>
              <el-form-item label="联系人">
                <el-input v-model="logisticsCarrier.contacts" style="width: 90%;"></el-input>
              </el-form-item>
              <el-form-item label="联系电话">
                <el-input v-model="logisticsCarrier.phone" style="width: 90%;"></el-input>
              </el-form-item>
              <el-form-item label="收货地址">
                <el-input v-model="logisticsCarrier.addr" style="width: 90%;"></el-input>
              </el-form-item>
              <el-form-item label="主营线路">
                <el-input v-model="logisticsCarrier.mainLine" style="width: 90%;"></el-input>
              </el-form-item>
              <el-form-item label="银行名及账号">
                <el-input v-model="logisticsCarrier.banksAccounts" style="width: 90%;"></el-input>
              </el-form-item>
              <el-form-item label="支付宝账号">
                <el-input v-model="logisticsCarrier.alipay" style="width: 90%;"></el-input>
              </el-form-item>
              <el-form-item label="微信账号">
                <el-input v-model="logisticsCarrier.wecatpay" style="width: 90%;"></el-input>
              </el-form-item>
              <el-form-item label="备注" width="200%" show-overflow-tooltip=false>
                <el-input type="textarea" v-model="logisticsCarrier.remark" style="width: 90%;"></el-input>
              </el-form-item>
              <el-form-item label="提交人">
                <el-input v-model="logisticsCarrier.submitter" disabled style="width: 90%;"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="newOrEditLogisticsCarrierVisible = false">取 消</el-button>
              <el-button type="primary" @click="subLogisticsCarrier()" style="margin-left: 20%;">提交</el-button>
            </div>
          </el-dialog>
        </dev>
        
      </div>
      
    </template>
    
<script>
  export default {
    data() {
      return {
        queryInfo: {
          orderNo: "",
          scopeDateTime: "",
          orderStatus: "",
          shop: "",
          customerId: "",
          customerPhone: "",
          pageNum: 1,
          pageSize: 10
        },
        logisticsCarrierList: [{
          carrierUnit: "承订单位",
          contacts: "联系人",
          phone: "联系电话",
          addr: "收货地址",
          mainLine: "主营线路",
          banksAccounts: "银行及账号",
          alipay: "支付宝账号",
          wecatpay: "微信支付账号",
          remark: "备注",
          submitter: "提交人"
        },
        {
          carrierUnit: "承订单位",
          contacts: "联系人",
          phone: "联系电话",
          addr: "收货地址",
          mainLine: "主营线路",
          banksAccounts: "银行及账号",
          alipay: "支付宝账号",
          wecatpay: "微信支付账号",
          remark: "备注",
          submitter: "提交人"
        },
        {
          carrierUnit: "承订单位",
          contacts: "联系人",
          phone: "联系电话",
          addr: "收货地址",
          mainLine: "主营线路",
          banksAccounts: "银行及账号",
          alipay: "支付宝账号",
          wecatpay: "微信支付账号",
          remark: "备注",
          submitter: "提交人"
        }],
        total: 3,
        
        //新增或修改物流承运商模态窗口
        newOrEditLogisticsCarrierVisible: false,
        logisticsCarrier: {
          carrierUnit: "",
          contacts: "",
          phone: "",
          addr: "",
          mainLine: "",
          banksAccounts: "",
          alipay: "",
          wecatpay: "",
          remark: "",
          submitter: ""
        }
      };
    },
    methods: {
      //添加物流承运商
      newLogisticsCarrier(){
        this.logisticsCarrier = {
          carrierUnit: "",
          contacts: "",
          phone: "",
          addr: "",
          mainLine: "",
          banksAccounts: "",
          alipay: "",
          wecatpay: "",
          remark: "",
          submitter: ""
        };
        this.newOrEditLogisticsCarrierVisible = true;
      },
      //修改物流承运商
      editLogisticsCarrier(index, logisticsCarrier){
        this.logisticsCarrier = logisticsCarrier;
        this.newOrEditLogisticsCarrierVisible = true;
      },
      //提交物流承运商
      subLogisticsCarrier(){
        if(this.logisticsCarrier.shopId == ""){
          //console.log(this.logisticsCarrier);
          this.$message({
            message: '添加物流承运商成功！',
            type: 'success'
          });
        }else{
          //console.log(this.logisticsCarrier);
          this.$message({
            message: '修改物流承运商成功！',
            type: 'success'
          });
        }
        
        this.newOrEditLogisticsCarrierVisible = false;
        
      }
      
    },
    created() {
      
    }
  };
</script>

<style>
</style>
